import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  forgotPassword,
  login,
  selectEmailIsRegister,
  selectIsAuthenticate,
} from "@/core/store/authSlice";
import { TextFieldComponent } from "components/basic/TextField";

type Props = {
  email: string;
};

export const RegisterUserPasswordField = React.memo(({ email }: Props) => {
  const [password, setPassword] = useState("");
  const dispatch = useAppDispatch();

  const isRegister = useAppSelector(selectEmailIsRegister);
  const isAuthenticate = useAppSelector(selectIsAuthenticate);

  return isRegister && !isAuthenticate ? (
    <div>
      <TextFieldComponent
        className="w-full"
        label="Password"
        type="password"
        placeholder="Log in for a faster experience"
        name="password"
        onChange={(e) => {
          const target = e.target as typeof e.target & {
            value: string;
          };
          setPassword(target.value);
        }}
        onKeyUp={(event: KeyboardEvent) => {
          if (event.key === "Enter") {
            event.preventDefault();
            dispatch(login({ email, password }));
          }
        }}
        value={password}
      ></TextFieldComponent>
      <button
        className="text-success text-sm mr-5"
        type="button"
        onClick={() => {
          dispatch(login({ email, password }));
        }}
      >
        Login
      </button>
      <button
        className="text-blue-500 text-sm"
        type="button"
        onClick={() => {
          dispatch(forgotPassword({ email }));
        }}
      >
        Forgot Password
      </button>
    </div>
  ) : (
    <></>
  );
});
